import { render, staticRenderFns } from "./bubble1.vue?vue&type=template&id=52d23582&scoped=true&"
import script from "./bubble1.vue?vue&type=script&lang=js&"
export * from "./bubble1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d23582",
  null
  
)

export default component.exports